import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    title: "Iniciar sesión",
    subtitle: "Accede a tu panel de organizador",
    password: "Contraseña",
    emailPlaceholder: "tu@email.com",
    forgot: "¿Olvidaste tu contraseña?",
    sessionExpired: "Tu sesión expiró. Inicia sesión de nuevo.",
    submit: "Entrar",
    noAccount: "¿No tienes cuenta?",
    register: "Registrarse",
    error: "Error al iniciar sesión",
  },
  en: {
    title: "Sign in",
    subtitle: "Access your organizer dashboard",
    password: "Password",
    emailPlaceholder: "you@email.com",
    forgot: "Forgot your password?",
    sessionExpired: "Your session expired. Please sign in again.",
    submit: "Sign in",
    noAccount: "Don't have an account?",
    register: "Sign up",
    error: "Couldn't sign in",
  },
});
